import { createRouter, createWebHistory } from "vue-router";

import store from "../store";
import NProgress from "nprogress";

import AreaMap from "../views/AreaMap.vue";
import Brochure from "../views/Brochure.vue";
import Gallery from "../views/Gallery.vue";
import GalleryList from "../views/GalleryList.vue";
import Home from "../views/Home.vue";
import Model from "../views/Model.vue";
import ModelList from "../views/ModelList.vue";
import MyFavorites from "../views/MyFavorites.vue";
import NotFound from "../views/NotFound.vue";
import Page from "../views/Page.vue";
import PageList from "../views/PageList.vue";
import SitePlan from "../views/SitePlan.vue";

// Route guard that checks a store getter before allowing navigation
const requireGetter = ( getter ) => () => {
    return store.getters[getter] ? true : { name: "Home" };
};

const routes = [
    {
        path: "/",
        name: "Home",
        component: Home
    },
    {
        path: "/area-map/",
        name: "AreaMap",
        component: AreaMap,
        beforeEnter: requireGetter( "hasAreamap" )
    },
    {
        path: "/site-plan/",
        name: "SitePlan",
        component: SitePlan,
        beforeEnter: requireGetter( "hasSiteplan" )
    },
    {
        path: "/floorplans/",
        name: "Floorplans",
        component: ModelList,
        props: { slug: "floorplans" },
        beforeEnter: requireGetter( "hasFloorplans" )
    },
    {
        path: "/floorplans/:id",
        name: "Floorplan",
        component: Model,
        props: route => ( { id: route.params.id, slug: "floorplans" } ),
        beforeEnter: requireGetter( "hasFloorplans" )
    },
    {
        path: "/move-in-ready/",
        name: "MoveInReady",
        component: ModelList,
        props: { slug: "inventory" },
        beforeEnter: requireGetter( "hasInventory" )
    },
    {
        path: "/move-in-ready/:id",
        name: "MoveInReadyHome",
        component: Model,
        props: route => ( { id: route.params.id, slug: "inventory" } ),
        beforeEnter: requireGetter( "hasInventory" )
    },
    {
        path: "/about-community/",
        name: "AboutTheCommunity",
        component: Page,
        props: { slug: "about" }
    },
    {
        path: "/galleries/",
        name: "GalleryList",
        component: GalleryList,
        props: { slug: "galleries" },
        beforeEnter: requireGetter( "hasGalleries" )
    },
    {
        path: "/galleries/:id",
        name: "Gallery",
        component: Gallery,
        props: route => ( { id: route.params.id, slug: "galleries" } ),
        beforeEnter: requireGetter( "hasGalleries" )
    },
    {
        path: "/about-kolter/",
        name: "AboutKolter",
        component: PageList,
        props: { slug: "kolter" },
        beforeEnter: requireGetter( "hasKolter" )
    },
    {
        path: "/about-kolter/:id",
        name: "AboutKolterPage",
        component: Page,
        props: route => ( { id: route.params.id, slug: "kolter" } ),
        beforeEnter: requireGetter( "hasKolter" )
    },
    {
        path: "/lifestyles/",
        name: "Lifestyles",
        component: PageList,
        props: { slug: "lifestyles" },
        beforeEnter: requireGetter( "hasLifestyles" )
    },
    {
        path: "/lifestyles/:id",
        name: "LifestylePage",
        component: Page,
        props: route => ( { id: route.params.id, slug: "lifestyles" } ),
        beforeEnter: requireGetter( "hasLifestyles" )
    },
    {
        path: "/my-favorites/",
        name: "MyFavorites",
        component: MyFavorites,
        beforeEnter: ( to, from ) => {
            const favorites = store.state.favorites.length;
            // if trying to open this without any favorites directly
            // send to home page
            if ( favorites === 0 && !from.name )
                router.push( "/" );
            else if ( favorites === 0 )
                store.dispatch( "openModal", { action:"favorites" } );
            // stop or allow based on favorites
            return favorites > 0 ? true : false;
        }
    },
    {
        path: "/brochure/:id",
        name: "Brochure",
        component: Brochure,
        props: route => ( { id: route.params.id, slug: "favorites" } )
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: NotFound
    }
];

const router = createRouter( {
    history: createWebHistory( process.env.BASE_URL ),
    routes
} );


router.beforeEach( async( to, from ) => {
    if ( !store.state.kiosk.id ){
        NProgress.start();
        await store.dispatch( "fetchKiosk" );
        NProgress.done();
    }

    // invalid and send to home
    if ( !store.state.kiosk.id && to.name !== "Home" )
        router.replace( "/" );
} );

export default router;
